(self["webpackChunkgrowwwtoday"] = self["webpackChunkgrowwwtoday"] || []).push([["/collection-description"],{

/***/ "./src/js/collection-description.js":
/*!******************************************!*\
  !*** ./src/js/collection-description.js ***!
  \******************************************/
/***/ (() => {

(function () {
  function initCollectionDescription() {
    var container = document.getElementById('collection-description-sections');
    if (!container) return;

    // Get translations from data attributes
    var readMoreText = container.getAttribute('data-read-more') || 'Lees meer';
    var readLessText = container.getAttribute('data-read-less') || 'Lees minder';

    // Check if already processed (has collection-section-block children)
    if (container.querySelector('.collection-section-block')) {
      return;
    }

    // Get raw HTML - preserve the original content
    var rawHtml = container.innerHTML.trim();
    if (!rawHtml) {
      console.warn('Collection description: No content found');
      return;
    }

    // Store original HTML in case we need to fall back
    var originalHtml = rawHtml;

    // Clear container
    container.innerHTML = '';

    // Create temporary div to parse HTML
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawHtml;

    // Split content by H2 headings
    var sections = [];
    var currentHeading = null;
    var currentContent = [];
    Array.from(tempDiv.childNodes).forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
        // Save previous section if exists
        if (currentHeading || currentContent.length > 0) {
          sections.push({
            heading: currentHeading,
            content: currentContent
          });
        }
        // Start new section
        currentHeading = node.cloneNode(true);
        currentContent = [];
      } else if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        // Add to current section content
        currentContent.push(node.cloneNode(true));
      }
    });

    // Add last section
    if (currentHeading || currentContent.length > 0) {
      sections.push({
        heading: currentHeading,
        content: currentContent
      });
    }

    // If no sections were created, restore original HTML and return
    if (sections.length === 0) {
      console.warn('Collection description: No sections found, restoring original content');
      container.innerHTML = originalHtml;
      return;
    }

    // Create blocks for each section
    sections.forEach(function (section, index) {
      // Skip empty sections - check if there's any meaningful content
      if (!section.heading && section.content.length === 0) {
        return;
      }

      // Check if all content is empty (only whitespace text nodes)
      if (!section.heading && section.content.length > 0) {
        var hasContent = section.content.some(function (node) {
          if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent.trim().length > 0;
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            return node.textContent.trim().length > 0 || node.children.length > 0;
          }
          return true;
        });
        if (!hasContent) {
          return;
        }
      }
      var sectionBlock = document.createElement('div');
      sectionBlock.classList.add('col-lg-6', 'col-12');
      var innerBlock = document.createElement('div');
      innerBlock.classList.add('collection-section-block');

      // Add heading if exists
      if (section.heading) {
        innerBlock.appendChild(section.heading.cloneNode(true));
      }

      // Create content wrapper
      var contentWrapper = document.createElement('div');
      contentWrapper.classList.add('collection-section-content');

      // Build full content HTML by cloning nodes
      var fullContentDiv = document.createElement('div');
      section.content.forEach(function (node) {
        fullContentDiv.appendChild(node.cloneNode(true));
      });

      // Get plain text for truncation
      var plainText = fullContentDiv.textContent || fullContentDiv.innerText || '';
      var words = plainText.trim().split(/\s+/).filter(function (word) {
        return word.length > 0;
      });
      var shortWordCount = 20;
      if (words.length > shortWordCount) {
        // Create preview paragraph
        var shortText = words.slice(0, shortWordCount).join(' ') + '...';
        var previewP = document.createElement('p');
        previewP.classList.add('collection-section-preview');
        previewP.style.marginBottom = '0';
        var previewText = document.createTextNode(shortText + ' ');
        previewP.appendChild(previewText);

        // Create "Read more" button (inline with preview)
        var readMoreBtn = document.createElement('button');
        readMoreBtn.type = 'button';
        readMoreBtn.classList.add('read-more-btn');
        readMoreBtn.innerHTML = '<span class="read-more-icon">+</span> <span class="read-more-text">' + readMoreText + '</span>';
        readMoreBtn.setAttribute('data-expanded', '0');

        // Create full content (hidden initially)
        var fullDiv = document.createElement('div');
        fullDiv.classList.add('collection-section-full');
        fullDiv.style.display = 'none';

        // Clone all content nodes into fullDiv
        section.content.forEach(function (node) {
          fullDiv.appendChild(node.cloneNode(true));
        });

        // Create "Read less" button for full content
        var readLessBtn = document.createElement('button');
        readLessBtn.type = 'button';
        readLessBtn.classList.add('read-more-btn');
        readLessBtn.innerHTML = '<span class="read-more-icon">−</span> <span class="read-more-text">' + readLessText + '</span>';
        readLessBtn.style.marginTop = '8px';

        // Add button to full content
        fullDiv.appendChild(readLessBtn);

        // "Read more" button click handler
        readMoreBtn.addEventListener('click', function (e) {
          e.preventDefault();
          previewP.style.display = 'none';
          fullDiv.style.display = 'block';
        });

        // "Read less" button click handler
        readLessBtn.addEventListener('click', function (e) {
          e.preventDefault();
          previewP.style.display = 'block';
          fullDiv.style.display = 'none';
        });

        // Append elements
        previewP.appendChild(readMoreBtn);
        contentWrapper.appendChild(previewP);
        contentWrapper.appendChild(fullDiv);
      } else {
        // Content is short, show all by appending nodes directly
        section.content.forEach(function (node) {
          contentWrapper.appendChild(node.cloneNode(true));
        });
      }
      innerBlock.appendChild(contentWrapper);
      sectionBlock.appendChild(innerBlock);
      container.appendChild(sectionBlock);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionDescription);
  } else {
    // DOM is already ready
    initCollectionDescription();
  }

  // Also listen for Shopify section:load event (for theme editor)
  document.addEventListener('shopify:section:load', initCollectionDescription);
})();

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/js/collection-description.js"));
/******/ }
]);